import { useState } from 'react';
import { Link } from 'react-router-dom';
import { MoreVertical, Plus, Trash2 } from 'lucide-react';
import { IconClipboardList } from '@tabler/icons-react';

import { CreateMicrostoreColumnPopup } from 'pages/MicrostoreColumnGroups/Popups/CreateMicrostoreColumnPopup';
import { DeleteMicrostoreColumnGroupPopup } from 'pages/MicrostoreColumnGroups/Popups/DeleteMicrostoreColumnGroupPopup';

import { Button } from '@/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

type Props = {
    columnGroup: { _id: string; columns: { _id: string }[] };
    onMutated: () => void;
};

export const ColumnGroupNodeActions = ({ columnGroup, onMutated }: Props) => {
    const [createColumnOpen, setCreateColumnOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);

    const wrapClose = (setter: (open: boolean) => void) => (open: boolean) => {
        setter(open);
        if (!open) onMutated();
    };

    return (
        <>
            <Link to={`/microstore-column-group/${columnGroup._id}`} data-test="more-details">
                <IconClipboardList size={22} className="text-foreground" />
            </Link>
            <Button
                size="icon-xs"
                variant="ghost"
                title="Ajouter une colonne"
                onClick={() => setCreateColumnOpen(true)}
            >
                <Plus />
            </Button>
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <Button size="icon-xs" variant="ghost" aria-label="Actions groupe">
                        <MoreVertical />
                    </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="min-w-44">
                    <DropdownMenuItem
                        variant="destructive"
                        onSelect={(event) => {
                            event.preventDefault();
                            setDeleteOpen(true);
                        }}
                    >
                        <Trash2 />
                        <span>Supprimer</span>
                    </DropdownMenuItem>
                </DropdownMenuContent>
            </DropdownMenu>
            <CreateMicrostoreColumnPopup
                isOpen={createColumnOpen}
                setIsOpen={wrapClose(setCreateColumnOpen)}
                columnGroup={columnGroup}
            />
            <DeleteMicrostoreColumnGroupPopup
                isOpen={deleteOpen}
                setIsOpen={wrapClose(setDeleteOpen)}
                microstoreColumnGroupToDelete={columnGroup}
            />
        </>
    );
};
